import { __values, __read } from './../../external_lib/tslib/tslib.es6.js';
import CssVariables from './CssVariables.js';
var LoadCssVariables = function () {
  var instance = null;
  function createInstance(variables) {
    function applyCssVariables() {
      var e_1, _a;
      var root = document.documentElement;
      try {
        for (var _b = __values(Object.entries(variables)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
            key = _d[0],
            value = _d[1];
          root.style.setProperty(key, value);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
    applyCssVariables();
    return {
      variables: variables
    };
  }
  return {
    init: function (variables) {
      if (!instance) {
        instance = createInstance(variables);
      }
      return instance;
    }
  };
}();
LoadCssVariables.init(CssVariables);
export { LoadCssVariables as default };
//# sourceMappingURL=LoadCssVariables.js.map
